<template>
  <b-container fluid>
    <p class="filter-title">Szűrők</p>
    <p class="filter-date-title">Dátum</p>
    <b-row class="mb-5">
      <b-col md="4">
        <p class="date-prefix">-tól</p>
        <b-form-datepicker
          locale="hu"
          label-no-date-selected="Időszak kezdete"
          reset-button
          reset-value="undefined"
          label-reset-button="Törlés"
          label-help=""
          @input="filterChanged('qualificationStart', $event)"
          class="mb-2"
          :value="filters.qualificationStart"
        >
        </b-form-datepicker>
        <input-error :errors="[qualificationStartError]" />
      </b-col>
      <b-col md="4">
        <p class="date-prefix">-ig</p>
        <b-form-datepicker
          locale="hu"
          label-no-date-selected="Időszak vége"
          reset-button
          reset-value="undefined"
          label-reset-button="Törlés"
          label-help=""
          @input="filterChanged('qualificationEnd', $event)"
          class="mb-2"
          :value="filters.qualificationEnd"
        >
        </b-form-datepicker>
        <input-error :errors="[qualificationEndError]" />
      </b-col>
      <b-col md="4" class="mb-5">
        <p class="font-weight-bold">Típus</p>
        <b-row class="type-text">
          <b-col md="6">
            <b-form-checkbox :checked="showApplication" @change="filterChanged('showApplication', $event)"
              >Pályázat</b-form-checkbox
            >
          </b-col>
          <b-col md="6">
            <b-form-checkbox :checked="showGuarantee" @change="filterChanged('showGuarantee', $event)"
              >Garanciatermék</b-form-checkbox
            >
          </b-col>
          <b-col md="6">
            <b-form-checkbox :checked="showCredit" @change="filterChanged('showCredit', $event)"
              >Hiteltermék</b-form-checkbox
            >
          </b-col>
          <b-col md="6">
            <b-form-checkbox :checked="showCapital" @change="filterChanged('showCapital', $event)"
              >Tőketermék</b-form-checkbox
            >
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-button class="mt-3 filter-modal-button" block @click="onFilterClicked()">Szűrés</b-button>
  </b-container>
</template>

<script>
import { competitionTypes } from '../../../constants/competitionTypes'
import { competitionStatus } from '../../../constants/competitionStatus'
import InputError from '../../../components/InputError.vue'
export default {
  components: { InputError },
  name: 'CompetitionListFilter',
  props: ['filters', 'onFilter', 'closeModal'],
  data: function() {
    return {
      showCapital: this.filters.showCapital,
      showGuarantee: this.filters.showGuarantee,
      showApplication: this.filters.showApplication,
      showCredit: this.filters.showCredit,
      qualificationStart: this.filters.qualificationStart,
      qualificationEnd: this.filters.qualificationEnd,
      qualificationEndError: undefined,
      qualificationStartError: undefined,
      competitionTypes,
      competitionStatus
    }
  },
  computed: {
    qualificationStartHasError: function() {
      return this.qualificationStart === undefined && this.qualificationEnd !== undefined
    },
    qualificationEndHasError: function() {
      return this.qualificationStart !== undefined && this.qualificationEnd === undefined
    }
  },
  methods: {
    filterChanged: function(key, value) {
      if (key === 'qualificationStart' || key === 'qualificationEnd') {
        if (key === 'qualificationStart') {
          this.qualificationStartError = undefined
        }
        if (key === 'qualificationEnd') {
          this.qualificationEndError = undefined
        }
        if (value === '') {
          value = undefined
        }
      }
      this[key] = value
    },
    onFilterClicked: function() {
      if (this.qualificationStartHasError || this.qualificationEndHasError) {
        if (this.qualificationStartHasError) {
          this.qualificationStartError = 'Kötelező mező'
        }
        if (this.qualificationEndHasError) {
          this.qualificationEndError = 'Kötelező mező'
        }
      } else {
        this.qualificationStartError = undefined
        this.qualificationEndError = undefined
        const data = { ...this.$data }
        delete data.qualificationEndError
        delete data.qualificationStartError
        delete data.competitionStatus
        delete data.competitionTypes
        this.onFilter(data)
        this.closeModal()
      }
    }
  }
}
</script>

<style>
.batch-margins {
  margin-top: 5px;
  margin-bottom: 5px;
}

.date-prefix {
  padding-left: 5px;
  padding-bottom: 3px;
  margin-top: 2.85rem;
  margin-bottom: 0;
  font-weight: bold;
  font-size: 10px;
  line-height: 12px;
  text-transform: uppercase;
  color: #636e72;
}

.filter-title {
  margin-top: 12px;
  font-size: 24px;
  line-height: 32px;
}
.filter-date-title {
  margin-bottom: -25px;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
}

.type-text {
  margin-top: 2.08rem;
}
</style>
